import TableCell from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';

const LinkTableCell = styled(TableCell)(({ theme }) => ({
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    }
}));

export default LinkTableCell;
